// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*팝업*/
.NewCstModal_bg__msGDt {
    display: none;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(0,0,0,0.5);
    z-index: 999;
}
.NewCstModal_new_cst__qmP5R{
    display: none;
    position: absolute;
    width: 390px;
    height: 213px;
    border-radius: 20px;
    background: #FFF;
    top:224px;
    left: 50%;
    margin-left: -112px;
    z-index: 9999;
    padding: 20px 30px;box-sizing: border-box;
}
.NewCstModal_new_cst__qmP5R input{
    display: flex;
    width: 330px;
    height: 50px;
    padding: 8px 9px;
    align-items: center;
    border-radius: 8px;
    border: 2px solid #ebebeb;
    box-sizing: border-box;
}
.NewCstModal_new_cst__qmP5R input:focus, .NewCstModal_new_cst__qmP5R input:active{border: 2px solid #51D7DF;}
.NewCstModal_top__4\\+ziB{display: flex; align-items: center;margin-bottom: 23px;}

.NewCstModal_close__Q302q{
    position: relative;
    top: 2px;
    margin-left: auto;
}

.NewCstModal_tit__RWbLJ{
    font-size: 18px;
    font-weight: 700;
}
.NewCstModal_new_cst__qmP5R button{
    position: absolute;
    bottom: 20px;
    right: 30px;;
    width: 110px;
    height: 36px;
    border-radius: 10px;
    background: #51D7DF;
    font-size: 18px;
    font-weight: 700;
    color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/components/NewCstModal.module.css"],"names":[],"mappings":"AAAA,KAAK;AACL;IACI,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,MAAM;IACN,OAAO;IACP,SAAS;IACT,QAAQ;IACR,2BAA2B;IAC3B,YAAY;AAChB;AACA;IACI,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,SAAS;IACT,SAAS;IACT,mBAAmB;IACnB,aAAa;IACb,kBAAkB,CAAgC,sBAAsB;AAC5E;AACA;IAGI,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAGR,mBAAmB;IAC3B,kBAAkB;IAClB,yBAAyB;IAEjB,sBAAsB;AAClC;AACA,kFAA4C,yBAAyB,CAAC;AACtE,yBAA+C,aAAa,EAAqD,mBAAmB,CAAC,mBAAmB,CAAC;;AAEzJ;IACI,kBAAkB;IAClB,QAAQ;IACR,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf","sourcesContent":["/*팝업*/\n.bg {\n    display: none;\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    background: rgba(0,0,0,0.5);\n    z-index: 999;\n}\n.new_cst{\n    display: none;\n    position: absolute;\n    width: 390px;\n    height: 213px;\n    border-radius: 20px;\n    background: #FFF;\n    top:224px;\n    left: 50%;\n    margin-left: -112px;\n    z-index: 9999;\n    padding: 20px 30px;-webkit-box-sizing: border-box;box-sizing: border-box;\n}\n.new_cst input{\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    width: 330px;\n    height: 50px;\n    padding: 8px 9px;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    border-radius: 8px;\n    border: 2px solid #ebebeb;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n}\n.new_cst input:focus, .new_cst input:active{border: 2px solid #51D7DF;}\n.top{display: -webkit-box;display: -ms-flexbox;display: flex; -webkit-box-align: center; -ms-flex-align: center; align-items: center;margin-bottom: 23px;}\n\n.close{\n    position: relative;\n    top: 2px;\n    margin-left: auto;\n}\n\n.tit{\n    font-size: 18px;\n    font-weight: 700;\n}\n.new_cst button{\n    position: absolute;\n    bottom: 20px;\n    right: 30px;;\n    width: 110px;\n    height: 36px;\n    border-radius: 10px;\n    background: #51D7DF;\n    font-size: 18px;\n    font-weight: 700;\n    color: #fff;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bg": `NewCstModal_bg__msGDt`,
	"new_cst": `NewCstModal_new_cst__qmP5R`,
	"top": `NewCstModal_top__4+ziB`,
	"close": `NewCstModal_close__Q302q`,
	"tit": `NewCstModal_tit__RWbLJ`
};
export default ___CSS_LOADER_EXPORT___;
